import React, { Component, Fragment } from "react";
import { Query, Mutation, withApollo } from "react-apollo";
import gql from "graphql-tag";
import { Link as LinkTo } from "react-router-dom";
import { USER_LINKS_QUERY } from "./Account";
import { PROFILE_QUERY } from "./Account";
import { USER_ID, AUTH_TOKEN } from "../constants";
import { handleUnauthorized } from "../utils";

const EDIT_PROFILE_QUERY = gql`
  query EditProfileQuery {
    editProfileQuery {
      name
      email
      created
      bio
      notifications
    }
  }
`;

const PROFILE_MUTATION = gql`
  mutation ProfileMutation(
    $email: String!
    $name: String!
    $bio: String!
    $notifications: Boolean!
  ) {
    profile(
      email: $email
      name: $name
      bio: $bio
      notifications: $notifications
    ) {
      email
      name
      bio
      notifications
    }
  }
`;

const DELETE_ACCOUNT = gql`
  mutation ProfileDelete($id: ID!) {
    deleteProfile(id: $id)
  }
`;

class EditAccount extends Component {
  state = {
    email: "",
    name: "",
    bio: "",
    message: "",
    confirmAccountDeletion: false,
    notifications: false,
  };

  checkUnauthorized(error) {
    handleUnauthorized(error, this.props.history);
  }

  componentDidMount() {
    this.props.client
      .query({
        query: EDIT_PROFILE_QUERY,
      })
      .then(({ data }) => {
        this.setState({
          email: data.editProfileQuery.email,
          name: data.editProfileQuery.name,
          bio: data.editProfileQuery.bio || "",
          notifications: data.editProfileQuery.notifications,
        });
      })
      .catch((err) => {
        this.checkUnauthorized(err);
      });
  }

  afterProfileMutation(store, data) {
    // Edit Profile query
    try {
      const userData = store.readQuery({
        query: EDIT_PROFILE_QUERY,
      });

      userData.editProfileQuery.email = data.profile.email;
      userData.editProfileQuery.name = data.profile.name;
      userData.editProfileQuery.bio = data.profile.bio;
      userData.editProfileQuery.notifications = data.profile.notifications;
      store.writeQuery({
        query: EDIT_PROFILE_QUERY,
        data: userData,
      });
    } catch (err) {
      console.log("No user feed data in cache to update");
    }

    // Profile query
    try {
      const userData = store.readQuery({
        query: PROFILE_QUERY,
        variables: { userId: localStorage.getItem(USER_ID) },
      });

      userData.profile.name = data.profile.name;
      userData.profile.bio = data.profile.bio;
      userData.profile.notifications = data.profile.notifications;
      store.writeQuery({
        query: PROFILE_QUERY,
        data: userData,
        variables: { userId: localStorage.getItem(USER_ID) },
      });
    } catch (err) {
      console.log("No user feed data in cache to update");
    }

    // User links query
    try {
      const userLinks = store.readQuery({
        query: USER_LINKS_QUERY,
      });
      userLinks.userFeed.links.forEach((link) => {
        link.postedBy.name = data.profile.name;
      });
      store.writeQuery({
        query: USER_LINKS_QUERY,
        data: userLinks,
      });
    } catch (err) {
      console.info("No user links query in cache to update");
    }

    // Invalidate the cached feed queries to force refetch
    try {
      Object.keys(store.data.data).forEach((key) => {
        key.match(/ROOT_QUERY.feed/) && store.data.delete(key);
      });
    } catch (err) {
      console.log("No feed query in cache to invalidate");
    }
  }

  render() {
    const { email, name, bio, notifications } = this.state;
    return (
      <Fragment>
        <Query query={EDIT_PROFILE_QUERY}>
          {({ loading, error }) => {
            if (error)
              return (
                <div className="mt2">
                  An error occured when fetching user data...
                </div>
              );
            if (loading)
              return <div className="mt2 animate-flicker">Loading...</div>;
            return (
              <Fragment>
                <div className="flex pt2">
                  <div className="sidebar label gray pr2 pt1">email:</div>
                  <input
                    type="text"
                    value={this.state.email}
                    onChange={(e) =>
                      this.setState({ email: e.target.value, message: "" })
                    }
                  />
                </div>
                <div className="flex pt2">
                  <div className="sidebar label gray pr2 pt1">name:</div>
                  <input
                    type="text"
                    value={this.state.name}
                    onChange={(e) =>
                      this.setState({ name: e.target.value, message: "" })
                    }
                  />
                </div>
                <div className="flex pt2 w-100">
                  <div className="sidebar label gray pr2 pt1">bio:</div>
                  <div className="textarea-container">
                    <textarea
                      name="bio"
                      rows="6"
                      value={this.state.bio}
                      onChange={(e) =>
                        this.setState({ bio: e.target.value, message: "" })
                      }
                    ></textarea>
                  </div>
                </div>
                <div className="flex pt2 w-100">
                  <div className="sidebar label gray pr2 pt1">emails:</div>
                  <div className="notification-settings-container">
                    <div>
                      <input
                        className="mr1"
                        type="checkbox"
                        id="subscribePostComments"
                        name="subscribe"
                        onChange={(e) => {
                          this.setState({
                            notifications: e.target.checked,
                            message: "",
                          });
                        }}
                        checked={notifications}
                      ></input>
                      <label>Email notification on replies</label>
                    </div>
                  </div>
                </div>
                {!!this.state.message.length && (
                  <div className="flex pt2">
                    <div className="sidebar label gray pr2 pt1"></div>
                    <div>{this.state.message}</div>
                  </div>
                )}
              </Fragment>
            );
          }}
        </Query>
        <div className="flex">
          <div className="sidebar label gray pr2"></div>
          <div>
            <Mutation
              mutation={PROFILE_MUTATION}
              variables={{ email, name, bio, notifications }}
              update={(store, { data }) =>
                this.afterProfileMutation(store, data)
              }
              onCompleted={(res) => {
                if (res.profile) {
                  this.setState({
                    message: "Saved",
                  });
                }
              }}
              onError={(err) => {
                if (err.graphQLErrors && err.graphQLErrors.length) {
                  this.setState({
                    message: err.graphQLErrors[0],
                  });
                } else {
                  this.setState({
                    message: "An error occured when changing the profile",
                  });
                }
              }}
            >
              {(mutation) => (
                <button
                  type="submit"
                  className="pointer mb3 mt2 button sg_update-bio"
                  onClick={mutation}
                >
                  save
                </button>
              )}
            </Mutation>
            <LinkTo to={`/account/${localStorage.getItem(USER_ID)}`}>
              <button type="submit" className="pointer ml1 mb3 button">
                {this.state.message === "Saved" ? "back" : "cancel"}
              </button>
            </LinkTo>
          </div>
        </div>
        <div className="flex pt2">
          <div className="sidebar label gray pr2 pt1">danger:</div>
          <div>
            {!this.state.confirmAccountDeletion && (
              <button
                type="submit"
                className="pointer button sg_delete-account"
                onClick={() => {
                  this.setState({
                    confirmAccountDeletion: true,
                  });
                }}
              >
                delete account
              </button>
            )}
            {this.state.confirmAccountDeletion && (
              <Fragment>
                <div>
                  Are you sure you want to delete your account? This action is
                  not reversible.
                </div>
                <div>
                  <button
                    type="submit"
                    className="pointer button mt2 mr1"
                    onClick={() => {
                      this.setState({
                        confirmAccountDeletion: false,
                      });
                    }}
                  >
                    cancel
                  </button>

                  <Mutation
                    mutation={DELETE_ACCOUNT}
                    variables={{ id: localStorage.getItem(USER_ID) }}
                    onCompleted={(res) => {
                      if (res.deleteProfile) {
                        localStorage.removeItem(AUTH_TOKEN);
                        localStorage.removeItem(USER_ID);
                        window.location.href = "/";
                      }
                    }}
                    onError={(err) => {
                      if (err.graphQLErrors) {
                        this.setState({
                          message: "An error occured when deleting the account",
                        });
                      }
                    }}
                  >
                    {(mutation) => (
                      <button
                        onClick={mutation}
                        type="submit"
                        className="danger pointer button mt2 sg_delete-account"
                      >
                        delete account
                      </button>
                    )}
                  </Mutation>
                </div>
              </Fragment>
            )}
            <div></div>
          </div>
        </div>
        <div className="flex pt2">
          <div className="sidebar label gray pr2 pt1">password:</div>
          <div>
            <LinkTo to="/resetpassword" className="no-underline link">
              <button type="submit" className="pointer button sg_reset-pw">
                change password
              </button>
            </LinkTo>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withApollo(EditAccount);



// WEBPACK FOOTER //
// ./src/components/EditAccount.js